// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/umweltpakt-bayern-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const umweltpaktBayern2DE: PageEntry = {
  id: "post.umweltpakt-bayern-2",
  locale: "de",
  slug: "umweltpakt-bayern-2",
  seo: {
    title: "Willkommen in der DIETZ-Familie | Dietz GmbH",
    description: "Willkommen in der DIETZ-Familie",
  },
  type: "post",
  h1: "Willkommen in der DIETZ-Familie",
  blocks: [
    { kind: "heading", level: 2, text: "Willkommen in der DIETZ-Familie" },
    { kind: "paragraph", text: "Am 1. September sind bei uns vier Azubis in ihre berufliche Zukunft gestartet. Wir wünschen euch auf diesem Wege noch einmal viel Erfolg, vor allem aber jede Menge Spaß bei eurer Ausbildung!" },
    { kind: "paragraph", text: "Übrigens: Wer sich über die Ausbildungsmöglichkeiten bei DIETZ und das duale Studium informieren will – hier entlang: https://www.dietz.eu/karriere/schueler/ ." }
  ],
};
